import * as Api from "src/app/api/api-types";
import { getEnumMember } from "src/utils";

export enum LocationStatusEnum {
  ActiveMoveRequest = "ActiveMoveRequest",
  Occupied = "Occupied",
  Open = "Open",
  OutOfService = "OutOfService",
}

export const LocationStatusColorMap = {
  [LocationStatusEnum.ActiveMoveRequest]: "blue-mid",
  [LocationStatusEnum.Occupied]: "magenta",
  [LocationStatusEnum.Open]: "green",
  [LocationStatusEnum.OutOfService]: "red",
};

export class LocationStatus {
  public constructor(args: ClassProperties<LocationStatus>) {
    this.value = args.value;
    this.id = args.id;
  }

  public readonly value: LocationStatusEnum;
  public readonly id: number;

  public static deserialize(data: Api.DashboardDoorStatus): LocationStatus {
    return new LocationStatus({
      value: getEnumMember(LocationStatusEnum, data.value),
      id: data.id,
    });
  }
}
